module.exports = __webpack_public_path__ + "static/media/cropping_04.74c6ce64.png";